import { gql } from "@apollo/client";
import { AccountTransactionFlowType } from "../types/AccountTransactionFlowType";

export const FIELDS = `
    id
    clientId
    clientName
    virtualAccountId
    flowNo
    currency
    direction
    transactionAmount
    associatedTransactionNo
    transactionTime
    remark
`;

export const GET_ACCOUNT_TRANSACTION_FLOW_LISTING = gql`
    query AccountTransactionFlowQuery($filters: AccountTransactionFlowFilterTypeInput,
                       $pageRequest: PageRequestTypeInput) {
        getAccountTransactionFlowPageable(filters: $filters, pageRequest: $pageRequest) {
            content{
                ${FIELDS}
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface AccountTransactionFlowListResponse {
    getAccountTransactionFlowPageable: AccountTransactionFlowResponseType;
}

export interface AccountTransactionFlowResponseType {
    content: AccountTransactionFlowType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

interface PageRequestType {
    page: number;
    size: number;
    sortBy: string;
    sortDirection: string;
}
